import React, { useEffect, useState } from "react";
import { HandCoins } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Switch } from "./ui/switch";

export const GivingSwitch = () => {
  const { refreshUser } = useAuth();
  const [open, setOpen] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings/giving").then(({ data }) => setOpen(data.giving_open)).catch(() => setOpen(false)); }, []);

  const toggle = async (v) => {
    setSaving(true);
    try {
      const { data } = await api.put("/settings/giving", { giving_open: v });
      setOpen(data.giving_open);
      toast.success(data.giving_open ? "Giving is now open to everyone" : "Giving is now limited to admins");
      refreshUser?.();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div className="bg-white rounded-2xl border border-[#EBE9E4] p-6 md:p-8 shadow-[0_8px_30px_rgba(45,45,45,0.04)]" data-testid="giving-settings">
      <div className="flex items-start gap-4">
        <div className="h-11 w-11 rounded-xl flex items-center justify-center shrink-0" style={{ background: "#FEF6D8" }}><HandCoins className="h-6 w-6" style={{ color: "#8a6a00" }} /></div>
        <div className="flex-1 min-w-0">
          <h2 className="font-head text-xl font-semibold">Giving</h2>
          <p className="text-sm mt-1" style={{ color: "var(--sj-text-2)" }}>
            Switch on once the payment method is ready. When on, Giving appears in everyone's menu and anyone signed in can give online. When off, only Church admins can see it.
          </p>
          <p className="text-sm font-semibold mt-3" data-testid="giving-status" style={{ color: open ? "var(--sj-primary)" : "var(--sj-text-3)" }}>
            {open === null ? "Loading…" : open ? "Open to everyone" : "Admins only"}
          </p>
        </div>
        <Switch data-testid="giving-open-switch" checked={!!open} disabled={open === null || saving} onCheckedChange={toggle} aria-label="Open Giving to everyone" />
      </div>
    </div>
  );
};
